import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useSelector, useDispatch } from "react-redux";
import clsx from "clsx";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Dashboard } from "../../assets/images/dashboard.svg";
import { ReactComponent as Live } from "../../assets/images/live.svg";
import { ReactComponent as Team } from "../../assets/images/team.svg";
import { ReactComponent as Ticket } from "../../assets/images/ticket.svg";
import { ReactComponent as Report } from "../../assets/images/report.svg";
import { ReactComponent as UserTraffic } from "../../assets/images/user-traffic.svg";
import { ReactComponent as UserTrafficActive } from "../../assets/images/user-traffic-active.svg";
import { ReactComponent as Knowledge } from "../../assets/images/base.svg";
// import { ReactComponent as Crm } from "../../assets/images/crm.svg";
import { ReactComponent as Setting } from "../../assets/images/setting.svg";
import { ReactComponent as DashboardActive } from "../../assets/images/dashboardactive.svg";
import { ReactComponent as LiveActive } from "../../assets/images/liveactive.svg";
import { ReactComponent as TeamActive } from "../../assets/images/teamactive.svg";
import { ReactComponent as TicketActive } from "../../assets/images/ticketactive.svg";
import { ReactComponent as ReportActive } from "../../assets/images/reportactive.svg";
import { ReactComponent as KnowledgeActive } from "../../assets/images/baseactive.svg";
// import { ReactComponent as CrmActive } from "../../assets/images/crmactive.svg";
import { ReactComponent as SettingActive } from "../../assets/images/settingactive.svg";
import { ReactComponent as People } from "../../assets/images/people.svg";
import { ReactComponent as PeopleActive } from "../../assets/images/peopleactive.svg";
import { ReactComponent as NotificationsNav } from "../../assets/images/notifications-nav.svg";
import { ReactComponent as NotificationsNavActive } from "../../assets/images/notifications-nav-active.svg";
import { ReactComponent as SearchNav } from "../../assets/images/search-nav.svg";
import { ReactComponent as SearchNavActive } from "../../assets/images/search-nav-active.svg";

import { ReactComponent as TrustChatLogo } from "../../assets/images/Trustchat1.svg";
import { ReactComponent as SidebarProfileChevron } from "../../assets/images/sidebar-profile-chevron.svg";
import { ReactComponent as MobileLogo } from "../../assets/images/mobileLogo.svg";
import LogoutPopout from "./LogoutMenu";
import LogoutPopUp from "./LogoutPopUp";
import { selectIsPopupOpen, openPopup, closePopup } from "../../Redux/toggle";
import { useLocation } from "react-router-dom";
import { chracterPosition } from "../../utils/index";
import { colorCodesForAvatar } from "../../constants/index";
import { getAgentStatus } from "../../store/features/getAgentStatus";
import { ReactComponent as GreenDot } from "../../assets/images/green-dot.svg";
import { ReactComponent as RedDot } from "../../assets/images/red-dot.svg";
import { ReactComponent as GreyDot } from "../../assets/images/grey-dot.svg";
import { createAppSocket } from '../../api/createAppSocket';
import { logoutAll } from "../../store/features/LogoutAll";
import { resetAgentUser } from "../../store/features/loginUserTenant";
import { logoutAgent } from "../../store/features/logoutAgent";
import { resetUser } from "../../store/features/loginUser";
import { toast } from "react-toastify";
import { logoutSingleDevice } from "../../store/features/LogoutSingleDevice";
import { getUserSessions } from "../../store/features/getUserSessions";
import { useMediaQuery } from "@mui/material";
import { unsubscribeUser } from "../../utils/notification";
import { clearSessionScopedState } from "../../utils/clearSessionScopedState";
import { hasMasterSession } from "../../utils/authSession";
import {
  isLegacyTeamManagementEnabled,
  isLegacySettingsEnabled,
  isPeopleModuleEnabled,
  isLegacyLiveChatEnabled,
  TICKETS_HOME_PATH,
  LIVE_CHAT_HOME_PATH,
  LIVE_CHAT_V2_PATH,
} from "../../config/featureFlags";
import { useNotificationOverlayOpen } from "../../context/NotificationOverlayContext";
import {
  saveNotificationsBackground,
  readNotificationsBackground,
  clearNotificationsBackground,
  pathFromBackground,
} from "../../utils/notificationsBackground";

const isSidebarItemVisible = (itemId) => {
  if (itemId === 4) return isLegacyTeamManagementEnabled;
  if (itemId === 9) return isPeopleModuleEnabled;
  if (itemId === 11) return isLegacySettingsEnabled;
  // "Live Chat V2" nav entry only while legacy Live is also available
  if (itemId === 21) return isLegacyLiveChatEnabled;
  return true;
};

function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const notificationsOpen = useNotificationOverlayOpen();
  const [activeButtonIndex, setActiveButtonIndex] = useState(0);
  const [expandedItems, setExpandedItems] = useState([]);
  const [logoutMenu, setLogoutMenu] = useState(false);
  const [showLogoutPopUp, setShowLogoutPopUp] = useState(false);
  const [logoutAllLoading, setLogoutAllLoading] = useState(false);
  const [logoutCurrentLoading, setLogoutCurrentLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");
  const dispatch = useDispatch();
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage]
  );
  const userData = useSelector((state) => state.loginToken);

  const uRole = userData.response?.user?.role_name;
  const agentData = useSelector((state) => state.loginTokenCoUser);
  const users = hasMasterSession(userData)
    ? userData.response
    : agentData.response;
  const [acceptChat, setAcceptChat] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(true);
  const socketRef = useRef();
  const KbRole = userData?.response?.user?.kbRole?.role

  // Track if component has mounted and initial setup is done
  const hasInitialized = useRef(false);
  // Track previous mobile state to detect actual changes
  const prevIsMobile = useRef(isMobile);

  const isPopupOpen = useSelector(selectIsPopupOpen);
  const notificationUnread = useSelector(
    (state) => state.notifications?.unreadCount ?? 0
  );
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const sideBarObjects = [
    {
      id: 12,
      logo: <SearchNav />,
      activeLogo: <SearchNavActive />,
      name: "Search",
      Link: "./search",
    },
    {
      id: 0,
      logo: <Dashboard />,
      activeLogo: <DashboardActive />,
      name: `${t.DASHBOARD}`,
      Link: "./dashboard",
    },
    {
      id: 1,
      logo: <UserTraffic />,
      activeLogo: <UserTrafficActive />,
      name: `${t.USER_TRAFFIC}`,
      Link: "./user-traffic",
    },

    {
      id: 2,
      logo: <Live />,
      activeLogo: <LiveActive />,
      name: `${t.LIVE}`,
      Link: LIVE_CHAT_HOME_PATH,
    },
    {
      id: 21,
      logo: <Live />,
      activeLogo: <LiveActive />,
      name: "Live Chat V2",
      Link: LIVE_CHAT_V2_PATH,
    },
    {
      id: 3,
      logo: <Ticket />,
      activeLogo: <TicketActive />,
      name: `${t.TICKET}`,
      Link: TICKETS_HOME_PATH,
    },
    {
      id: 4,
      logo: <Team />,
      activeLogo: <TeamActive />,
      name: `${t.TEAM}`,
      Link: "./teamsection",
    },
    {
      id: 9,
      logo: <Team />,
      activeLogo: <TeamActive />,
      name: "People",
      Link: "./people/customers",
      hasSubItems: true,
      subItems: [
        { id: "9-1", name: "Customers", Link: "people/customers" },
        { id: "9-2", name: "Teams", Link: "people/teams" },
        { id: "9-3", name: "Agents", Link: "people/agents" },
        { id: "9-4", name: "Groups", Link: "people/groups" },
      ],
    },
    {
      id: 5,
      logo: <Knowledge />,
      activeLogo: <KnowledgeActive />,
      name: `${t.KNOW}`,
      Link: "./kb/overview",
      hasSubItems: true,
      subItems: [
        {
          id: "5-1",
          name: "Overview",
          Link: "kb/overview",
        },
        {
          id: "5-2",
          name: "Articles",
          Link: "kb/articles",
        },
        {
          id: "5-3",
          name: "Categories",
          Link: "kb/categories",
        },
        ...(KbRole === "editor"
          ? [
            {
              id: "5-4",
              name: "Review Queue",
              Link: "kb/review-queue",
            },
            {
              id: "5-5",
              name: "Feedback Queue",
              Link: "kb/feedback-queue",
            },
          ]
          : KbRole === "contributor"
            ? [
              {
                id: "5-5",
                name: "Feedback Queue",
                Link: "kb/feedback-queue",
              },
            ]
            : []),

        ...(KbRole === "editor"
          ? [
            {
              id: "5-6",
              name: "Customization",
              Link: "kb/customization",
            },
          ]
          : []),
      ],
    },
    // {
    //   id: 6,
    //   logo: <Crm />,
    //   activeLogo: <CrmActive />,
    //   name: `${t.CRM}`,
    //   Link: "./dashboard",
    // },
    {
      id: 7,
      logo: <Report />,
      activeLogo: <ReportActive />,
      name: `${t.REPORT}`,
      Link: "./analytics/overview",
      hasSubItems: true,
      subItems: [
        {
          id: "7-1",
          name: "Overview",
          Link: "analytics/overview",
        },
        {
          id: "7-2",
          name: "Chats",
          Link: "analytics/chats",
        },
        {
          id: "7-3",
          name: "Tickets",
          Link: "analytics/tickets",
        },
        {
          id: "7-4",
          name: "Agents",
          Link: "analytics/agents",
        },
        {
          id: "7-5",
          name: "Knowledge Base",
          Link: "analytics/knowledgeBase",
        },
        {
          id: "7-6",
          name: "Export & Reports",
          Link: "analytics/data-export",
        },
      ],
    },
    {
      id: 10,
      logo: <NotificationsNav />,
      activeLogo: <NotificationsNavActive />,
      name: "Notifications",
      Link: "./notifications",
      isOverlay: true,
    },
    {
      id: 8,
      logo: <Setting />,
      activeLogo: <SettingActive />,
      name: `${t.SETTING}`,
      Link: "./settings/personal/account-security",
      hasSubItems: true,
      subItems: [
        {
          id: "8-1",
          name: "Personal Settings",
          Link: "./settings/personal/account-security",
          matchPrefix: "settings/personal",
        },
        ...(uRole === "admin" || uRole === "admin_with_billing"
          ? [
            {
              id: "8-2",
              name: "Admin Settings",
              Link: "./settings/admin",
              matchPrefix: "settings/admin",
            },
          ]
          : []),
      ],
    },
    ...(isLegacySettingsEnabled
      ? [
        {
          id: 11,
          logo: <Setting />,
          activeLogo: <SettingActive />,
          name: "Legacy Settings",
          Link: "./settings/profile",
          hasSubItems: true,
          subItems: [
            {
              id: "11-1",
              name: "Account & Profile",
              Link: "./settings/profile",
            },
            ...(uRole === "admin" || uRole === "admin_with_billing"
              ? [
                {
                  id: "11-2",
                  name: "Company Settings",
                  Link: "./settings/company-settings",
                },
              ]
              : []),
            {
              id: "11-3",
              name: "Notifications",
              Link: "./settings/notifications",
            },
            ...(uRole === "admin" || uRole === "admin_with_billing"
              ? [
                {
                  id: "11-4",
                  name: "Chat Widget",
                  Link: "./settings/chat-widget",
                },
              ]
              : []),
            {
              id: "11-5",
              name: "Data Export",
              Link: "./settings/data-export",
            },
          ],
        },
      ]
      : []),
  ].filter((item) => isSidebarItemVisible(item.id));

  const sidebarRef = useRef();

  // FIXED: Only handle initial mount, ignore subsequent resize events
  useEffect(() => {
    // Only run on first mount
    if (!hasInitialized.current) {
      if (isMobile) {
        dispatch(openPopup());
      } else {
        dispatch(closePopup());
      }
      hasInitialized.current = true;
      prevIsMobile.current = isMobile;
    }
  }, []); // Empty dependency array - only runs once on mount

  useEffect(() => {
    if (notificationsOpen) {
      setActiveButtonIndex(10);
      setExpandedItems([]);
      return;
    }

    const currentPath = location.pathname.slice(1);

    const isKbArticleDetail =
      currentPath === "kb/article" || currentPath.startsWith("kb/article/");
    const fromReviewQueue = Boolean(location.state?.fromReviewQueue);

    const activeItem = sideBarObjects.find((item) => {
      if (!item || !item.Link) return false;
      const link = item.Link.startsWith("./")
        ? item.Link.slice(2)
        : item.Link.startsWith("/")
          ? item.Link.slice(1)
          : item.Link;
      if (item.id === 2) {
        return (
          currentPath === "Live" ||
          currentPath === "chat" ||
          currentPath.startsWith("chat/") ||
          currentPath === "live" ||
          currentPath.startsWith("live/") ||
          currentPath === "chatv2" ||
          link === currentPath
        );
      }
      return link === currentPath;
    });

    let activeSubItem = null;
    let parentId = null;

    sideBarObjects.forEach((item) => {
      if (item.subItems) {
        const foundSubItem = item.subItems.find((subItem) => {
          const subLink = subItem.Link.startsWith("./")
            ? subItem.Link.slice(2)
            : subItem.Link.startsWith("/")
              ? subItem.Link.slice(1)
              : subItem.Link;
          if (item.id === 5 && isKbArticleDetail) {
            if (fromReviewQueue) {
              return subLink === "kb/review-queue";
            }
            return subLink === "kb/articles";
          }
          if (subItem.matchPrefix) {
            return currentPath.startsWith(subItem.matchPrefix);
          }
          return (
            subLink === currentPath ||
            currentPath.startsWith(`${subLink}/`)
          );
        });
        if (foundSubItem) {
          activeSubItem = foundSubItem;
          parentId = item.id;
        }
      }
    });

    if (activeSubItem) {
      setActiveButtonIndex(activeSubItem.id);
      setExpandedItems([parentId]);
    } else if (activeItem) {
      setActiveButtonIndex(activeItem.id);
      if (activeItem.hasSubItems) {
        setExpandedItems([activeItem.id]);
      } else {
        setExpandedItems([]);
      }
    } 
    else 
    {
      setActiveButtonIndex(-1);
      setExpandedItems([]);
    }
  }, [location.pathname, location.state, notificationsOpen]);

  const toggleLogoutMenu = (e) => {
    e.stopPropagation();
    setLogoutMenu((prev) => !prev);
  };

  const handleClose = () => {
    setLogoutMenu(false);
  };

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = async () => {
    setIsStatusLoading(true);
    const listCoUserList = dispatch(
      getAgentStatus({
        id: userData?.response?.user?._id,
      })
    );

    listCoUserList
      .then(async (data) => {
        if (data?.payload?.success) {
          if (data?.payload?.accept_chat !== acceptChat) {
            setAcceptChat(data?.payload?.accept_chat);
          }
        }
        setIsStatusLoading(false);
      })
      .catch(async (error) => {
        setIsStatusLoading(false);
      });
  };

  useEffect(() => {
    const currentPath = location.pathname.slice(1);
    const isTicketsPage =
      currentPath === "tickets" ||
      currentPath.startsWith("tickets/") ||
      currentPath === "ticketsection" ||
      currentPath.startsWith("ticketsection/") ||
      currentPath === "ticketv2" ||
      currentPath.startsWith("ticketv2/");
    // Keep app sidebar collapsed on Live/Chat V2 and Tickets (more room for the page UI)
    if (
      currentPath === "Live" ||
      currentPath === "chat" ||
      currentPath.startsWith("chat/") ||
      currentPath === "live" ||
      currentPath.startsWith("live/") ||
      currentPath === "chatv2" ||
      isTicketsPage
    ) {
      dispatch(openPopup());
    } else if (isMobile) {
      // Keep closed on mobile for other screens too
      dispatch(openPopup());
    }
  }, [location.pathname, dispatch, isMobile]);

  const handleSidebarClick = (itemId) => {
    if (typeof itemId === "number") {
      const item = sideBarObjects.find((obj) => obj.id === itemId);

      if (item?.isOverlay) {
        if (notificationsOpen) {
          const bg = readNotificationsBackground();
          clearNotificationsBackground();
          navigate(pathFromBackground(bg));
        } else {
          setActiveButtonIndex(itemId);
          if (expandedItems.length > 0) {
            setExpandedItems([]);
          }
          // Capture the real page URL before navigating to the overlay
          const backgroundLocation = saveNotificationsBackground({
            pathname: window.location.pathname,
            search: window.location.search || "",
            hash: window.location.hash || "",
          });
          navigate("/notifications", {
            state: { backgroundLocation },
          });
        }
        return;
      }

      if (item?.hasSubItems) {
        if (isPopupOpen) {
          dispatch(closePopup());
        }

        if (!expandedItems.includes(itemId)) {
          setExpandedItems([itemId]);
        }

        if (
          item.subItems?.length > 0 &&
          !item.subItems.some((sub) => sub.id === activeButtonIndex)
        ) {
          const firstSubItem = item.subItems[0];
          setActiveButtonIndex(firstSubItem.id);
          navigate(firstSubItem.Link);
        }

        return;
      }

      if (expandedItems.length > 0) {
        setExpandedItems([]);
      }

      setActiveButtonIndex(itemId);
      navigate(item.Link);
    } else if (typeof itemId === "string" && itemId.includes("-")) {
      setActiveButtonIndex(itemId);

      const parent = sideBarObjects.find((obj) =>
        obj.subItems?.some((si) => si.id === itemId)
      );
      const subItem = parent?.subItems.find((si) => si.id === itemId);

      if (subItem) {
        navigate(subItem.Link);
      }
    }
  };

  const handleUpdateChatStatus = (agentId, status) => {
    if (agentId === userData?.response?.user?._id) {
      setAcceptChat(status);
    }
  };

  useEffect(() => {
    socketRef.current = createAppSocket();
    socketRef.current.on("get-status", handleUpdateChatStatus);
    return () => {
      socketRef.current.off("get-status", handleUpdateChatStatus);
    };
  }, []);

  const handleLogoutClick = () => {
    setShowLogoutPopUp(true);
    setLogoutMenu(false);
  };

  const handleCloseLogoutPopUp = () => {
    setShowLogoutPopUp(false);
  };

  const logoutSingleUser = () => {
    socketRef.current.emit(
      "logout-single-agent",
      userData?.response?.user?._id
    );
  };

  const logoutSingleHandler = async () => {
    try {
      await unsubscribeUser({ clearAll: false });
      const result = await dispatch(getUserSessions());
      const sessionList = result.payload?.sessions || [];
      console.log("sessionList", sessionList.length === 1);
      if (sessionList.length === 1) {
        console.log("sessionList", sessionList);
        logoutSingleUser();
        clearSessionScopedState();
        localStorage.clear();
        window.location.href = "/login";
        localStorage.removeItem("auth_token");
      } else {
        clearSessionScopedState();
        localStorage.clear();
        window.location.href = "/login";
        localStorage.removeItem("auth_token");
      }
    } catch (error) {
      clearSessionScopedState();
      localStorage.clear();
      window.location.href = "/login";
      localStorage.removeItem("auth_token");
      console.error("Error during logout:", error);
    }
  };

  const handleLogoutCurrent = async () => {
    setLogoutCurrentLoading(true);
    try {
      const result = await dispatch(logoutSingleDevice());
      if (logoutSingleDevice.rejected.match(result)) {
        toast.error("Couldn't sign you out. Check your connection and try again.");
        return;
      }
      await logoutSingleHandler();
    } catch (error) {
      toast.error("Logout failed. Please try again later.");
      setLogoutCurrentLoading(false);
    } finally {
      setLogoutCurrentLoading(false);
      setShowLogoutPopUp(false);
    }
  };

  const logoutAllHandler = async () => {
    await unsubscribeUser({ clearAll: true });
    logoutUser();
    dispatch(resetUser());
    dispatch(resetAgentUser());
    clearSessionScopedState();
    localStorage.setItem("logout", Date.now());
    localStorage.removeItem("auth_token");
    navigate("/login", { replace: true });
  };

  const logoutUser = async () => {
    socketRef.current.emit("logout-agent", userData?.response?.user?._id);
    const CoUserUpdates = dispatch(
      logoutAgent({
        requestHeaders: {
          agentId: userData?.response?.user?._id,
          adminId: userData?.response?.user?._id,
        },
      })
    );
    CoUserUpdates.then(async (data) => {
      if (typeof data.payload === "undefined") {
        toast.error("Some Error Occurred. Please try again later.");
      } else if (data?.payload?.status === 200) {
        getUserlList();
      } else if (data?.payload?.status === 400) {
      }
    }).catch(async (error) => {
      toast.error(error);
    });
  };

  const handleLogoutAll = async () => {
    setLogoutAllLoading(true);
    try {
      const resultAction = await dispatch(logoutAll());
      if (logoutAll.fulfilled.match(resultAction)) {
        await logoutAllHandler();
      } else {
        toast.error("Couldn't sign out of all devices. Check your connection and try again.");
      }
    } catch (error) {
      console.error("Logout failed:", error);
      setLogoutAllLoading(false);
    } finally {
      setLogoutAllLoading(false);
      setShowLogoutPopUp(false);
    }
  };

  return (
    <>
      <div className={`left-sidebar ${isPopupOpen ? "closed" : ""}`}>
        {!isPopupOpen ? (
          <div className="sidebar-logo" onClick={() => navigate("/dashboard")}>
            <TrustChatLogo />
          </div>
        ) : (
          <div className="sidebar-logo" onClick={() => navigate("/dashboard")}>
            <MobileLogo />
          </div>
        )}
        <div className="sidebar-content">
          {sideBarObjects.map((item) => (
            <div key={item.id}>
              <div
                className="dashboard-section"
                onClick={() => handleSidebarClick(item.id)}
              >
                <Link
                  to={item.isOverlay ? "/notifications" : item.Link}
                  style={{ textDecoration: "none", lineHeight: 0 }}
                  className={clsx("dashboard-container", {
                    active: item.id === activeButtonIndex,
                  })}
                  onClick={(e) => {
                    if (item.isOverlay) {
                      e.preventDefault();
                    }
                  }}
                >
                  {(() => {
                    const isActive =
                      item.id === activeButtonIndex ||
                      (item.hasSubItems && expandedItems.includes(item.id));
                    const iconInner = isActive ? item.activeLogo : item.logo;

                    const icon = item.isOverlay ? (
                      <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        invisible={notificationUnread === 0}
                        variant="dot"
                        sx={{
                          display: "inline-flex",
                          lineHeight: 0,
                          height: 24,
                          width: 24,
                          "& .MuiBadge-badge": {
                            right: 4,
                            top: 0,
                            border: "1.5px solid #FFF",
                            padding: 0,
                            height: "8px",
                            minWidth: "8px",
                            borderRadius: "50%",
                            backgroundColor: "#FF4D4F",
                            transform: "none",
                          },
                        }}
                      >
                        <span
                          style={{
                            height: 24,
                            width: 24,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {iconInner}
                        </span>
                      </Badge>
                    ) : (
                      <span style={{ height: 24, width: 24, display: "inline-flex" }}>
                        {iconInner}
                      </span>
                    );

                    if (isActive) {
                      return icon;
                    }

                    return (
                      <LightTooltip title={item.name} placement="top">
                        {icon}
                      </LightTooltip>
                    );
                  })()}

                  {!isPopupOpen ? (
                    <p
                      className={clsx("common-text", {
                        active:
                          item.id === activeButtonIndex ||
                          (item.hasSubItems && expandedItems.includes(item.id)),
                      })}
                    >
                      {item.name}
                    </p>
                  ) : (
                    ""
                  )}
                </Link>
              </div>

              {!isPopupOpen &&
                item.hasSubItems &&
                expandedItems.includes(item.id) && (
                  <div className="sub-items-container">
                    {item.subItems?.map((subItem) => (
                      <div
                        key={subItem.id}
                        className="dashboard-section sub-item"
                        onClick={() => handleSidebarClick(subItem.id)}
                      >
                        <Link
                          to={subItem.Link}
                          style={{ textDecoration: "none" }}
                          className={clsx("dashboard-container sub-item-link", {
                            active: subItem.id === activeButtonIndex,
                          })}
                        >
                          <span
                            className={clsx("sub-item-text", {
                              active: subItem.id === activeButtonIndex,
                            })}
                          >
                            {subItem.name}
                          </span>
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          ))}
        </div>

        <div className="sidebar-footer" ref={sidebarRef}>
          <div onClick={toggleLogoutMenu}>
            {!isPopupOpen ? (
              <div className="footer-container">
                <div className="sidebar-profile-avatar-wrap">
                  {users?.user &&
                    (users?.user?.agent_image ? (
                      <Avatar
                        src={users.user.agent_image}
                        alt={users.user.full_name}
                        sx={{ width: 32, height: 32, fontSize: 14 }}
                      />
                    ) : (
                      <Avatar
                        sx={{
                          width: 32,
                          height: 32,
                          fontSize: 14,
                          bgcolor:
                            colorCodesForAvatar[
                            chracterPosition(
                              (users?.user?.full_name || "")
                                .substring(0, 1)
                                .toUpperCase()
                            )
                            ],
                        }}
                      >
                        {(users?.user?.full_name || "")
                          .substring(0, 1)
                          .toUpperCase()}
                      </Avatar>
                    ))}
                  <span className="sidebar-profile-status">
                    {isStatusLoading ? (
                      <GreyDot />
                    ) : acceptChat ? (
                      <GreenDot />
                    ) : (
                      <RedDot />
                    )}
                  </span>
                </div>
                <div className="weilJenny-container">
                  <p className="wilson">{users?.user?.full_name || ""}</p>
                </div>
                <SidebarProfileChevron
                  className={`arrow ${logoutMenu ? "rotate-arrow" : ""}`}
                />
              </div>
            ) : (
              <div className="sidebar-footer-mbl">
                <div className="sidebar-profile-avatar-wrap">
                  {users?.user?.agent_image ? (
                    <Avatar
                      src={users?.user?.agent_image}
                      alt={users?.user?.full_name}
                      sx={{ width: 32, height: 32, fontSize: 14 }}
                    />
                  ) : (
                    <Avatar
                      sx={{
                        width: 32,
                        height: 32,
                        fontSize: 14,
                        bgcolor:
                          colorCodesForAvatar[
                          chracterPosition(
                            (users?.user?.full_name || "")
                              .substring(0, 1)
                              .toUpperCase()
                          )
                          ],
                      }}
                    >
                      {(users?.user?.full_name || "")
                        .substring(0, 1)
                        .toUpperCase()}
                    </Avatar>
                  )}
                  <span className="sidebar-profile-status">
                    {isStatusLoading ? (
                      <GreyDot />
                    ) : acceptChat ? (
                      <GreenDot />
                    ) : (
                      <RedDot />
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
          {logoutMenu && (
            <LogoutPopout
              onClose={handleClose}
              parentRef={sidebarRef}
              acceptChat={acceptChat}
              handleUpdateChatStatus={handleUpdateChatStatus}
              setAcceptChat={setAcceptChat}
              isStatusLoading={isStatusLoading}
              onLogoutClick={handleLogoutClick}
            />
          )}
        </div>
      </div>
      <LogoutPopUp
        open={showLogoutPopUp}
        onClose={handleCloseLogoutPopUp}
        onLogoutCurrent={handleLogoutCurrent}
        onLogoutAll={handleLogoutAll}
        logoutAllLoading={logoutAllLoading}
        logoutCurrentLoading={logoutCurrentLoading}
      />
    </>
  );
}

export default SideBar;
